module.exports = __webpack_public_path__ + "img/certification-hecho.045ebc5b.png";